import { render, staticRenderFns } from "./LagerBlock.vue?vue&type=template&id=bceb7780&"
import script from "./LagerBlock.vue?vue&type=script&lang=js&"
export * from "./LagerBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports